import { Stats } from "../../../state/types";
import { StatScores } from "./StatScores";

// TODO Check deze waarden, zelf bedacht
const legend = [
  { low: 0, name: "Stil", color: "#3C5941" },
  { low: 2, name: "Bijna stil", color: "#5E7658" },
  { low: 3, name: "Hoorbaar", color: "#819470" },
  {
    low: 4.5,
    name: "Goed hoorbaar",
    color: "#A7B38A",
  },
  { low: 6, name: "Geluid", color: "#D0D2A6" },
  {
    low: 8,
    name: "Storend geluid",
    color: "#FBF2C4",
  },
  { low: 10, name: "Veel geluid", color: "#E0B881" },
  { low: 12, name: "Ernstige overlast", color: "#D7995E" },
];

const mapping = {
  buren: "Burenoverlast",
  vlieg: "Vliegverkeer",
  trein: "Treinverkeer",
  weg: "Wegverkeer",
  weg_meer50: "Weg > 50m",
  weg_min50: "Weg < 50m",
};
export const Nuisance = ({ stats }: { stats: Stats }) => {
  /*
  Eigen straat:

  buren: 5.9,
  vlieg: 1.4,
  trein: 0.3,
  weg: 6.4,
  weg_meer50: 5.3,
  weg_min50: 4.1

  Centrum:

  buren: 11.7,
  vlieg: 1.8,
  trein: 0.9,
  weg: 11.9,
  weg_meer50: 2.7,
  weg_min50: 11
   */
  if (!stats?.buren) return null;
  const calculated = {
    ...stats,
    score: Object.keys(mapping).reduce((acc, attr) => Math.max(stats[attr], acc), 0),
  };
  return <StatScores stats={calculated} mapping={mapping} title="Geluid in wijk" legend={legend} />;
};
